import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import orderFuc from "@/utils/order.js";
import MemberOrderDetail from "./components/MemberOrderDetail.vue";
import MemberOrderRefund from "./components/MemberOrderRefund.vue";
import MemberOrderRefundDetail from "./components/MemberOrderRefundDetail.vue";
import AddressForm from "../../components/AddressForm.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";
export default {
  name: "MemberOrder",
  components: {
    MemberOrderDetail: MemberOrderDetail,
    MemberOrderRefund: MemberOrderRefund,
    MemberOrderRefundDetail: MemberOrderRefundDetail,
    AddressForm: AddressForm
  },
  data: function data() {
    return {
      current: this.$route.query.tab || "2",
      list: [],
      showDetailDialog: false,
      detail: {},
      page: 1,
      limit: 15,
      total: 0,
      showCommentDialog: false,
      commentDetail: {},
      commentInfo: {
        grade: 5,
        content: ""
      },
      addressInfo: null
    };
  },
  computed: {
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    types: function types() {
      var types = [{
        type: "2",
        label: "课程订单"
      }];

      if (this.commonSetting.switch_class_module === 1) {
        types.push({
          type: "8",
          label: "班级订单"
        });
      }

      if (this.commonSetting.switch_contract_schedule === 1) {
        types.push({
          type: "6",
          label: "课时包订单"
        });
      }

      if (this.commonSetting.switch_oto_module == 1) {
        types.push({
          type: "1",
          label: "约课订单"
        });
      }

      if (this.commonSetting.switch_goods_module === 1) {
        types.push({
          type: "4",
          label: "实物商品订单"
        });
      }

      if (this.commonSetting.switch_ebook_module === 1) {
        types.push({
          type: "11",
          label: "电子书订单"
        });
      } // if (this.$store.getters.showVip) {
      //   types.push({
      //     type: "9",
      //     label: "会员订单",
      //   });
      // }


      if (this.commonSetting.switch_question_module === 1) {
        types.push({
          type: "10",
          label: "套卷订单"
        });
      }

      return types;
    }
  },
  watch: {
    $route: function () {
      var _$route = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.page = 1;
                this.current = this.$route.query.tab || "2";
                _context.next = 4;
                return this.getData();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $route() {
        return _$route.apply(this, arguments);
      }

      return $route;
    }()
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var type;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              type = this.$route.query.type;

              if (type) {
                if (type == 1) {
                  this.current = "1";
                } else if (type == 14) {
                  this.current = "3";
                } else if (type == 12) {
                  this.current = "4";
                } else {
                  this.current = "2";
                }
              }

              _context2.next = 4;
              return this.getData();

            case 4:
              triggerLoaded(this);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    onShowRefundDetail: function onShowRefundDetail(item) {
      this.$refs.refundDetail.show(item);
    },
    applyRefund: function applyRefund(item) {
      this.$refs.refund.applyRefund(item);
    },
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$http.post("/api/app/myOrder", {
                  order_type: this.current,
                  page: this.page,
                  limit: this.limit
                });

              case 2:
                data = _context3.sent;
                data.data.forEach(function (item) {
                  var desc = orderFuc.getListDescData(item);
                  var text = desc.text;
                  item.status_name = text ? text.list : "";
                  item.status_id = desc.id;
                  item.is_can_refund = item.is_can_refund == 1 && (item.status_id == 3 || item.status_id == 4 || item.status_id == 5 || item.status_id == 6 || item.status_id == 13 || item.status_id == 14);

                  if (item.is_virtual == 2 && item.ship_status == 3 && item.auto_confirm_at > 0) {
                    item.timer = setInterval(function () {
                      if (item.auto_confirm_at == 0) {
                        _this.autoConfirmShip(item.id);
                      }

                      item.auto_confirm_at--;
                    }, 1000);
                  } // item.can_refund = 1
                  // for(let son of item.items){
                  //   if(son.shop_status==3||son.shop_status==6){
                  //     item.can_refund = 0
                  //     return
                  //   }
                  // }

                });
                this.list = data.data;
                this.total = data.total;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    changeTab: function () {
      var _changeTab = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(item) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$router.replace({
                  name: this.$route.name,
                  query: {
                    tab: item.name
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changeTab(_x) {
        return _changeTab.apply(this, arguments);
      }

      return changeTab;
    }(),
    goToPay: function goToPay(order) {
      this.$router.push({
        name: "OrderPay",
        params: {
          id: order.id
        },
        query: {
          type: order.shop_type,
          spell_id: order.spell_id
        }
      });
    },
    cancelOrder: function () {
      var _cancelOrder = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(item) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$confirm("确定要取消订单么？", "提示", {
                  type: "warning"
                });

              case 2:
                _context5.next = 4;
                return this.$http.post("/api/app/myOrder/cancel", {
                  order_id: item.id
                });

              case 4:
                this.$success("取消成功");
                _context5.next = 7;
                return this.getData();

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function cancelOrder(_x2) {
        return _cancelOrder.apply(this, arguments);
      }

      return cancelOrder;
    }(),
    showDetail: function () {
      var _showDetail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(id) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.$router.push({
                  name: "MemberOrderDetail",
                  params: {
                    id: id
                  },
                  query: {
                    current: this.current
                  }
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function showDetail(_x3) {
        return _showDetail.apply(this, arguments);
      }

      return showDetail;
    }(),
    handlePageChange: function () {
      var _handlePageChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(page) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.page = page;
                _context7.next = 3;
                return this.getData();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handlePageChange(_x4) {
        return _handlePageChange.apply(this, arguments);
      }

      return handlePageChange;
    }(),
    autoConfirmShip: function () {
      var _autoConfirmShip = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(id) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.$http.put("/api/app/orderShip/confirm/" + id);

              case 2:
                _context8.next = 4;
                return this.getData();

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function autoConfirmShip(_x5) {
        return _autoConfirmShip.apply(this, arguments);
      }

      return autoConfirmShip;
    }(),
    confirmShip: function () {
      var _confirmShip = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(id) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.$confirm("请收到货物后再点击确认收货，确认收货么？", "提示", {
                  type: "warning"
                });

              case 2:
                _context9.next = 4;
                return this.autoConfirmShip(id);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function confirmShip(_x6) {
        return _confirmShip.apply(this, arguments);
      }

      return confirmShip;
    }(),
    comment: function comment(item) {
      this.showCommentDialog = true;
      this.commentInfo.content = "";
      this.commentInfo.grade = 5;
      this.commentDetail = item;
    },
    submitComment: function () {
      var _submitComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this.commentDetail.is_comment == 1)) {
                  _context10.next = 3;
                  break;
                }

                this.showCommentDialog = false;
                return _context10.abrupt("return");

              case 3:
                if (!(this.commentInfo.grade == 0)) {
                  _context10.next = 7;
                  break;
                }

                _context10.next = 6;
                return this.$info("请选择星级");

              case 6:
                return _context10.abrupt("return");

              case 7:
                if (!(this.commentInfo.content == "")) {
                  _context10.next = 11;
                  break;
                }

                _context10.next = 10;
                return this.$info("请输入评价内容");

              case 10:
                return _context10.abrupt("return");

              case 11:
                _context10.next = 13;
                return this.$http.post("/api/app/goods/comment", {
                  grade: this.commentInfo.grade,
                  content: this.commentInfo.content,
                  goods_id: this.commentDetail.shop_ids,
                  order_num: this.commentDetail.order_number
                });

              case 13:
                this.showCommentDialog = false;
                this.commentDetail.is_comment = 1;
                _context10.next = 17;
                return this.$success("评价成功");

              case 17:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function submitComment() {
        return _submitComment.apply(this, arguments);
      }

      return submitComment;
    }(),
    onOpenAdress: function () {
      var _onOpenAdress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(item) {
        var address;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.$http.get("/api/app/address/".concat(item.address_id));

              case 2:
                address = _context11.sent;
                address.orderId = item.id;
                this.addressInfo = address;
                this.$refs.form.showForm();

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onOpenAdress(_x7) {
        return _onOpenAdress.apply(this, arguments);
      }

      return onOpenAdress;
    }(),
    changeAddress: function changeAddress(params) {
      var _this2 = this;

      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12(resolve) {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return _this2.$http.put("/api/app/myOrder/address/modify/".concat(_this2.addressInfo.orderId), params);

                case 2:
                  resolve();

                case 3:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        return function (_x8) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    chanageSuccess: function chanageSuccess() {
      this.$message.success("修改地址成功");
      this.getData();
    }
  }
};